module.exports = __webpack_public_path__ + "img/SLS-Icon-Fire.5d800761.svg";